<template>
  <div id="app">
    <div class="LBox">
      <div class="LContainer">
        <div class="licensesTitle">Licenses</div>
        <div class="licenses">
        Copyright &copy; 2025. Supported by Nanjing Forestry University.</div>
        <div class="licenses">
          PMGD is free for academic use only. For any commercial use, please
          contact us for commercial licensing terms.</div>
        <div class="licenses">
          ICP备案/许可证号: <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2026004503号-1</a >&nbsp;&nbsp;
          <img src="https://qcloudimg.tencent-cloud.cn/raw/eed02831a0e201b8d794c8282c40cf2e.png" style="width: 14px; margin-right: 5px;">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32010202012324" target="_blank">苏公网安备32010202012324号</a >
        </div>
        
      </div>
    </div>

  </div>
</template>
  
  <script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Licenses",
};
</script>
  <style>
.LBox {
  width: 100%;
  height: 160px;
  background-color: rgb(235, 233, 232);
}
.licensesTitle {
  font-size: 20px;
  font-weight: 600;
  color: #999;
}
.licenses {
    margin: 20px 0;
}
.LContainer {
  width: 1300px;
  height: 150px;
  margin: auto;
}
.licenses a {
  color: #666;
  text-decoration: none;
  transition: color 0.2s ease;
}
.licenses a:hover {
  color: #333;
  text-decoration: underline;
}
</style>